module.exports = __webpack_public_path__ + "fonts/junction-regular.cd2ab954.woff";